import ResultsListItemWithState from "../../../js/external_datasets/search/ResultsListItem";

export default ResultsListItemWithState;
